
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as setupmlJSOy_45smkHquzyidOQNMwLcHPWyl1H5bzYsUUGQU_454Meta } from "/vercel/path0/pages/setup.vue?macro=true";
import { default as account7_45R9ulYiZeZ_45GrHnPC281Y5Zif3_45d2qTALfK0BMjqEUMeta } from "/vercel/path0/pages/account.vue?macro=true";
import { default as message2G_45crHiyJqaCdFiT7CUsAFRgzcoCEKq33WfKxO9TlIkMeta } from "/vercel/path0/pages/message.vue?macro=true";
import { default as requestUg_HIdFVxJLOXX6woxaPL6Bn7UcncJN7R21_Ql1ixQEMeta } from "/vercel/path0/pages/request.vue?macro=true";
import { default as supportnA_45IDlPaAjaQsA8ejz2uVrUOW723JN_MsEEEqK7KeZEMeta } from "/vercel/path0/pages/support.vue?macro=true";
import { default as registerYVQw2hrVHVB4lGWKPyo5FmqMHpKgdBVJqzomEM8zf3IMeta } from "/vercel/path0/pages/register.vue?macro=true";
import { default as schedulesQPirNnvtCJ0VAZvdg2M3tVUzB1s_45sILc1JmOrjzgI_QMeta } from "/vercel/path0/pages/schedules.vue?macro=true";
import { default as setupF41g55gKulaw3LlJ2IG4x4wPswIAEajJHy5_o1Ja8DEMeta } from "/vercel/path0/pages/demo/setup.vue?macro=true";
import { default as email_45checkfTd6xF7qabMhADudWtb6Wpfa27nOZdjxG6tTysdt_45OMMeta } from "/vercel/path0/pages/email-check.vue?macro=true";
import { default as account8AKrPCwos_GfEX4D9a_45XXXWUx39X9o4ferpGTqHZmZwMeta } from "/vercel/path0/pages/demo/account.vue?macro=true";
import { default as messagek_45a2ZnXlbFvyfQRPUB4w9feGM6R33_UCxc0nRZ95dhYMeta } from "/vercel/path0/pages/demo/message.vue?macro=true";
import { default as requestRhLW_45zfrVOz7s0lac3e4uNL8V13jHP56G_69c2rVpHAMeta } from "/vercel/path0/pages/demo/request.vue?macro=true";
import { default as support1_45_45ARea3I1VvpVHVvT_45MR8mawATiq2ZXX5cXnR17OfwMeta } from "/vercel/path0/pages/demo/support.vue?macro=true";
import { default as schedulesBbmsitsZCSsg7Kv4riOYUd4yEhfX4KUhdBxrR72O9qcMeta } from "/vercel/path0/pages/demo/schedules.vue?macro=true";
import { default as password_45reseth3sJlq_02LH1wXudGLM176YWHhy3RbZ5GjcvA8t_45kPMMeta } from "/vercel/path0/pages/password-reset.vue?macro=true";
import { default as recovery_45checkT39lwyfd_wJfssbNbb_45YE0tNxWiozQf3qTmLL_9fD_45sMeta } from "/vercel/path0/pages/recovery-check.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginyiubrZraL9EDD3J38Z_45ftLpCUym9OoYm1Hb9453rWnMMeta || {},
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "setup",
    path: "/setup",
    meta: setupmlJSOy_45smkHquzyidOQNMwLcHPWyl1H5bzYsUUGQU_454Meta || {},
    component: () => import("/vercel/path0/pages/setup.vue")
  },
  {
    name: "account",
    path: "/account",
    meta: account7_45R9ulYiZeZ_45GrHnPC281Y5Zif3_45d2qTALfK0BMjqEUMeta || {},
    component: () => import("/vercel/path0/pages/account.vue")
  },
  {
    name: "message",
    path: "/message",
    meta: message2G_45crHiyJqaCdFiT7CUsAFRgzcoCEKq33WfKxO9TlIkMeta || {},
    component: () => import("/vercel/path0/pages/message.vue")
  },
  {
    name: "request",
    path: "/request",
    meta: requestUg_HIdFVxJLOXX6woxaPL6Bn7UcncJN7R21_Ql1ixQEMeta || {},
    component: () => import("/vercel/path0/pages/request.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: supportnA_45IDlPaAjaQsA8ejz2uVrUOW723JN_MsEEEqK7KeZEMeta || {},
    component: () => import("/vercel/path0/pages/support.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerYVQw2hrVHVB4lGWKPyo5FmqMHpKgdBVJqzomEM8zf3IMeta || {},
    component: () => import("/vercel/path0/pages/register.vue")
  },
  {
    name: "schedules",
    path: "/schedules",
    meta: schedulesQPirNnvtCJ0VAZvdg2M3tVUzB1s_45sILc1JmOrjzgI_QMeta || {},
    component: () => import("/vercel/path0/pages/schedules.vue")
  },
  {
    name: "demo-setup",
    path: "/demo/setup",
    meta: setupF41g55gKulaw3LlJ2IG4x4wPswIAEajJHy5_o1Ja8DEMeta || {},
    component: () => import("/vercel/path0/pages/demo/setup.vue")
  },
  {
    name: "email-check",
    path: "/email-check",
    meta: email_45checkfTd6xF7qabMhADudWtb6Wpfa27nOZdjxG6tTysdt_45OMMeta || {},
    component: () => import("/vercel/path0/pages/email-check.vue")
  },
  {
    name: "demo-account",
    path: "/demo/account",
    meta: account8AKrPCwos_GfEX4D9a_45XXXWUx39X9o4ferpGTqHZmZwMeta || {},
    component: () => import("/vercel/path0/pages/demo/account.vue")
  },
  {
    name: "demo-message",
    path: "/demo/message",
    meta: messagek_45a2ZnXlbFvyfQRPUB4w9feGM6R33_UCxc0nRZ95dhYMeta || {},
    component: () => import("/vercel/path0/pages/demo/message.vue")
  },
  {
    name: "demo-request",
    path: "/demo/request",
    meta: requestRhLW_45zfrVOz7s0lac3e4uNL8V13jHP56G_69c2rVpHAMeta || {},
    component: () => import("/vercel/path0/pages/demo/request.vue")
  },
  {
    name: "demo-support",
    path: "/demo/support",
    meta: support1_45_45ARea3I1VvpVHVvT_45MR8mawATiq2ZXX5cXnR17OfwMeta || {},
    component: () => import("/vercel/path0/pages/demo/support.vue")
  },
  {
    name: "demo-schedules",
    path: "/demo/schedules",
    meta: schedulesBbmsitsZCSsg7Kv4riOYUd4yEhfX4KUhdBxrR72O9qcMeta || {},
    component: () => import("/vercel/path0/pages/demo/schedules.vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: password_45reseth3sJlq_02LH1wXudGLM176YWHhy3RbZ5GjcvA8t_45kPMMeta || {},
    component: () => import("/vercel/path0/pages/password-reset.vue")
  },
  {
    name: "recovery-check",
    path: "/recovery-check",
    meta: recovery_45checkT39lwyfd_wJfssbNbb_45YE0tNxWiozQf3qTmLL_9fD_45sMeta || {},
    component: () => import("/vercel/path0/pages/recovery-check.vue")
  }
]